<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Concierge Rules'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    <tidy-row>
      <tidy-text [header]="'Popular Rules'" />
    </tidy-row>

    @for (rule of popularRules; track rule; let last = $last) {
      <tidy-card>
        <tidy-row>
          <tidy-text
            [body]="rule"
            style="margin-right: 10px;" />
          <tidy-text
            [clickableBody]="'<u>Add</u>'"
            (action)="addRule(rule)"
            class="link" />
        </tidy-row>
      </tidy-card>
    }

    <tidy-row>
      <tidy-text [header]="'Concierge Rules'" />
    </tidy-row>

    @for (item of forms.controls; track item; let i = $index; let first = $first) {
      <tidy-row>
        <form [formGroup]="item">
          <tidy-textarea
            label="Rule"
            formControlName="rule"
            [icon]="'assets/svg/information-circle.svg'"
            [form]="item"
            [submitted]="submitted"
            [errorMessage]="'Please enter the rule.'" />
          @if (!first) {
            <tidy-row [align]="'end'">
              <tidy-text
                [actionBody]="'Remove'"
                (action)="removeRule(i)"
                class="link red" />
            </tidy-row>
          }
        </form>
      </tidy-row>
    }
    <tidy-row [align]="'center'" class="extra-bottom-padding">
      <tidy-text
        [clickableBody]="'<u>+ Add Another Rule</u>'"
        (action)="addRule()"
        class="link" />
    </tidy-row>

    <tidy-button
      [action]="boundSaveRule"
      class="primary"
      [text]="forms.length > 0 ? 'Save Rules' : 'Save Rule'" />
  </tidy-wrapper>
</ng-template>

@if (!windowService?.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (windowService?.isDesktopRes) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
